// extracted by mini-css-extract-plugin
export default {"formGroupParent":"UpdateAccountForm_formGroupParent__aeqYU"};